import { generatePath } from 'react-router-dom';
import { stringifyFilters } from './Filters/queryTransformers';
import { DatasetsFormFields } from './DatasetFilters/types';

const PATH = 'data';

export const MAIN_DATA_PATH = `/${PATH}`;
export const DATASET_LIST_PATH = `/${PATH}/data-sets`;
export const SINGLE_DATASET_TABS = { fields: 'fields', description: 'description' } as const;
export const SINGLE_DATASET_PATH = `/${PATH}/data-sets/:datasetId/:tab(${SINGLE_DATASET_TABS.fields}|${SINGLE_DATASET_TABS.description})?`;
export const DATA_FIELD_PATH = `/${PATH}/data-fields/:fieldId`;
export const OLD_DATA_FIELD_PATH = `/${PATH}/data-sets/:datasetId/data-fields/:fieldId`; //this is for backward compatibility with old links
export const DATA_FIELD_LIST_PATH = `/${PATH}/data-fields`;
export const DATA_SEARCH_RESULT_PATH = `/${PATH}/search/:tab(data-fields|data-sets)?`;

export const getMainDataPath = () => MAIN_DATA_PATH;

interface DatasetPathParams {
  queryParams?: Partial<Record<keyof DatasetsFormFields & { region: string; delay: string; universe: string }, string>>;
}

export const getDatasetsPath = ({ queryParams }: DatasetPathParams = {}) => {
  const query = queryParams ? stringifyFilters(queryParams) : '';
  return `${DATASET_LIST_PATH}${query}`;
};

export interface DatasetPathCategoryParams {
  categoryId?: string;
  subcategoryId?: string;
}

export const getDatasetsPathWithCategory = (params: DatasetPathCategoryParams) => {
  return getDatasetsPath({ queryParams: { category: params.categoryId, subcategory: params.subcategoryId } });
};

export type DatasetTabParam = 'fields' | 'description';

export const getSingleDatasetPath = ({ datasetId, tab, query = '' }: { datasetId: string; tab?: DatasetTabParam; query?: string }) =>
  generatePath(SINGLE_DATASET_PATH, { datasetId, tab }) + query;

interface DataFieldPathParams {
  datasetId: string;
  fieldId: string;
  query?: string;
}
export const getDataFieldPath = ({ fieldId, query = '' }: DataFieldPathParams) => {
  return `${generatePath(DATA_FIELD_PATH, { fieldId })}${query}`;
};

export const getBrowseDataFieldsPath = ({ searchParam }: { searchParam?: string } = {}) => {
  return `${DATA_FIELD_LIST_PATH}${searchParam ? `?search=${searchParam}` : ''}`;
};

export type DataSearchResultTabParam = 'data-fields' | 'data-sets';
export const getDataSearchResultPath = ({ tab, searchParam }: { tab?: DataSearchResultTabParam; searchParam?: string }) => {
  return `${generatePath(DATA_SEARCH_RESULT_PATH, { tab })}${searchParam ? `?search=${searchParam}` : ''}`;
};
